import { State } from '../StateTypes';

/**
 * Select sprs
 * @param sprs
 */
export const selectSprs = ({ sprs }: State) => (sprs ? sprs : []);

/**
 * Select sprs to display
 * @param state
 */
export const selectSprsToDisplay = (state: State) =>
  selectSprs(state)
    .filter(({ showInGallery }) => !!showInGallery)
    .sort((a, b) => a.sort - b.sort);

/**
 * Select sprs to display - abTest purposes only
 * @param state
 */
export const selectSprsSortedByItemQuantity = (state: State) => {
  const sprs = selectSprs(state).filter(({ showInGallery }) => !!showInGallery);
  const sortByFalling = sprs.slice(0);

  sortByFalling.sort(function (a, b) {
    return (
      (b.kompisSPR.content?.child || []).reduce(
        (sum, item) => sum + item.quantity,
        0
      ) -
      (a.kompisSPR.content?.child || []).reduce(
        (sum, item) => sum + item.quantity,
        0
      )
    );
  });
  return sortByFalling;
};
